import { PendingSkillAttachmentsPanel, SkillAttachmentsPanel, SkillSectionActions } from '@/components/projects'
import { useSkillDetailContext } from '@/hooks'

export function SkillAttachmentsPage() {
  const { projectId, skill, canEdit, isSaving, pendingAttachments, onPendingAttachmentsChange } = useSkillDetailContext()

  return (
    <div className="flex h-full flex-col gap-4 overflow-y-auto rounded-2xl border border-border bg-card p-5" data-testid="skill-attachments-section">
      {!skill && <SkillSectionActions />}
      <div className="flex min-h-0 flex-1 flex-col">
        {skill ? (
          <SkillAttachmentsPanel projectId={projectId} skillId={skill.id} canEdit={canEdit} />
        ) : (
          <PendingSkillAttachmentsPanel files={pendingAttachments} onFilesChange={onPendingAttachmentsChange} isLocked={isSaving} />
        )}
      </div>
    </div>
  )
}
